import { ajaxSend } from '../../../../api/api';

type PayloadT = {
  csid: string;
  userId: string;
};

type HoldPayloadT = PayloadT & {
  hold: boolean;
};

export function addCallerRequest({ csid, userId }: PayloadT) {
  return ajaxSend({
    method: 'PUT',
    path: `/v2/conversations/${csid}/add`,
    data: { userId },
  });
}

export function removeCallerRequest({ csid, userId }: PayloadT) {
  return ajaxSend({
    method: 'PUT',
    path: `/v2/conversations/${csid}/remove`,
    data: { userId },
  });
}

export function setHoldStatusOnCallerRequest({
  hold,
  csid,
  userId,
}: HoldPayloadT) {
  return ajaxSend({
    method: 'PUT',
    path: `/v2/conversations/${csid}/hold`,
    data: { userId, hold },
  });
}
